/* Stores */
import useDomStore from 'Stores/Dom';

/* Components */
import Icon from 'Components/Icon';
import DotsLoader from 'Components/DotsLoader';
import { useEffect } from 'react';

const ModalHeader = ({ title, navigation, button }) => {
	const setModalBodyLocked = useDomStore(state => state.setModalBodyLocked);

	useEffect(() => {
		if (button && button.isLoading) {
			setModalBodyLocked(true);
		} else {
			setModalBodyLocked(false);
		}
	}, [button && button.isLoading]);

	return (
		<div className="modal-header">
			<div className="left">
				{navigation.icon ? <Icon isHM name={navigation.icon} onClick={navigation.action} /> : null }
				<span className={`header4 ${navigation.icon ? '' : 'no-ml'}`}>{title}</span>
			</div>
			{ button && button.action ? (
				<div className="action">
					<button type="button" onClick={button.action} className={`${button.isIcon ? 'no-bg' : ''} ${button.theme ? button.theme : ''}`}>
						{ button.isIcon ? <Icon name={button.label} /> : button.label}
						{ button.isLoading ? <DotsLoader /> : null}
					</button>
				</div>
			) : null }
		</div>
	);
};

ModalHeader.propTypes = {
	title: PropTypes.string,
	navigation: PropTypes.shape({
		icon: PropTypes.string,
		action: PropTypes.func
	}),
	button: PropTypes.shape({
		label: PropTypes.string,
		isIcon: PropTypes.bool,
		isLoading: PropTypes.bool,
		action: PropTypes.func,
		theme: PropTypes.string
	})
};

ModalHeader.defaultProps = {
	title: null,
	navigation: null,
	button: null
};

export default ModalHeader;
